var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _line, _path118;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 428,
    viewBox: "0 0 349 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228 146C228 144.895 228.895 144 230 144H252C253.105 144 254 144.895 254 146V160C254 161.105 253.105 162 252 162H230C228.895 162 228 161.105 228 160V146ZM240.527 160.676H241.476C241.712 160.676 241.903 160.485 241.903 160.25V156.752C241.903 156.516 241.712 156.325 241.476 156.325H240.527C240.291 156.325 240.099 156.516 240.099 156.752V160.25C240.099 160.485 240.291 160.676 240.527 160.676ZM241.476 149.68H240.527C240.291 149.68 240.099 149.489 240.099 149.249V145.752C240.099 145.516 240.291 145.325 240.527 145.325H241.476C241.712 145.325 241.903 145.516 241.903 145.752V149.254C241.903 149.489 241.712 149.68 241.476 149.68ZM233.738 153.903H237.244C237.48 153.903 237.671 153.712 237.671 153.476V152.529C237.671 152.294 237.48 152.103 237.244 152.103H233.738C233.502 152.103 233.31 152.294 233.31 152.529V153.476C233.31 153.712 233.502 153.903 233.738 153.903ZM244.332 153.472V152.525C244.332 152.289 244.523 152.098 244.759 152.098H248.266C248.502 152.098 248.693 152.289 248.693 152.525V153.472C248.693 153.707 248.502 153.898 248.266 153.898H244.759C244.523 153.898 244.332 153.707 244.332 153.472ZM235.225 158.094L235.898 158.765C236.067 158.934 236.339 158.934 236.504 158.765L238.985 156.29C239.155 156.121 239.155 155.85 238.985 155.685L238.313 155.014C238.143 154.845 237.872 154.845 237.707 155.014L235.225 157.49C235.06 157.654 235.06 157.925 235.225 158.094ZM244.3 150.987C244.136 151.156 243.864 151.156 243.694 150.987L243.022 150.316C242.852 150.152 242.852 149.881 243.022 149.712L245.503 147.236C245.668 147.067 245.94 147.067 246.109 147.236L246.782 147.907C246.951 148.072 246.951 148.343 246.782 148.512L244.3 150.987Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 3.06006L91.71 3.70006C91.71 3.70006 79.86 3.79006 75.18 8.17006C70.5 12.5501 63.86 23.8301 62.07 27.9101C60.28 32.0001 50.07 91.7401 50.07 91.7401L48.75 109.27L44.54 170.46L46.58 172.67L46.49 187.22L43 191.56H35.17V197.09H40.79V209.52L48.88 234.12H51.05V230.8L55.65 232.84V251.99H50.42L49.02 246.12H42.51L38.68 242.67V230.54C38.68 230.54 26.17 241.39 22.59 247.65C19.02 253.91 8.72 278.97 9.31 304.67L11.18 307.39V312.67L5.56 316.76C5.56 316.76 4.2 375.82 10.58 390.89C16.96 405.96 15.64 402.42 15.64 402.42C15.64 402.42 20.41 408.57 25.13 409.27C29.85 409.97 60.7 409.27 60.7 409.27L78.91 413.44L174.74 414.97",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.71 3.69995C91.71 3.69995 88.45 12.17 87.6 21.61C86.75 31.06 83.51 95.8199 83.51 95.8199",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 95.8301H69.56C69.56 95.8301 54.92 97.0201 52.54 113.53L48.71 173.06C48.71 173.06 48.27 177.63 50.16 177.63C52.05 177.63 174.76 177.63 174.76 177.63",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 98.52H70.91C70.91 98.52 57.23 99.63 55.01 115.06L51.43 170.68C51.43 170.68 51.02 174.95 52.78 174.95C54.54 174.95 174.75 174.95 174.75 174.95",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.15 177.64L74.66 204C74.66 204 76.1 205.5 76.83 205.66C77.56 205.82 104.34 205.66 104.34 205.66H151.96H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.05 212.81H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.73 246.13C45.73 246.13 72.62 297.45 72.79 334.47L66.45 333.07M66.45 333.07C66.45 333.07 65.98 316.79 60.36 305.24C54.74 293.69 28.32 276.64 28.32 276.64C28.32 276.64 22.51 272.62 17.72 279.32C17.72 279.32 14.7 283.13 14.66 286.98C14.62 290.83 14.66 318.26 14.66 318.26C14.66 318.26 18.62 321.96 24.36 323.75C30.1 325.54 66.45 333.07 66.45 333.07Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.17 312.68C11.17 312.68 11.21 320.49 13.51 323.87C15.81 327.25 19.77 331.08 27.55 333.19C35.34 335.3 66.61 341.1 66.61 341.1C66.61 341.1 74.84 343.59 75.55 347.23L72.78 334.46",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45 325.78C5.45 325.78 6.66999 333.06 11.18 336.89C15.69 340.72 57.56 349.66 57.56 349.66C57.56 349.66 74.99 352.6 76.58 357.32L75.56 347.23",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.13 364.34L45.04 365.36C45.04 365.36 48.81 366.13 49.64 369.57C50.47 373.02 52.36 384.55 52.36 384.55L41.01 383.83C41.01 383.83 35.55 383.79 32.87 379.15C30.19 374.51 28.78 366.89 28.78 366.89C28.78 366.89 28.06 364.11 31.13 364.34Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.81 364.33L30.36 361.02C30.36 361.02 24.49 360.38 24.74 365.49C25 370.6 29.97 381.58 29.97 381.58C29.97 381.58 32.65 386.11 38.01 387.32C43.37 388.53 65.33 389.87 65.33 389.87",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.85 364.33C77.85 364.33 79.32 375.39 82.96 382.09C86.6 388.79 91.58 394.41 104.53 395.11V413.86",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.54 395.1H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 386.38C174.75 386.38 123.98 386.47 107.43 386.38C90.88 386.29 90.09 369.02 90.09 369.02C90.09 369.02 89.68 364.64 92.96 364.68C96.24 364.72 174.75 364.68 174.75 364.68",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 342.64C174.75 342.64 98.2 342.77 87.77 342.64C77.34 342.51 73.48 337.65 73.48 337.65C73.48 337.65 78.58 351.23 83.43 351.23C88.28 351.23 174.75 351.23 174.75 351.23",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 334.08C174.75 334.08 94.04 335.2 88.39 334.08C82.74 332.96 81.82 325.78 81.82 325.78L77.86 241.87C77.86 241.87 77.56 234.04 87.86 234.21C98.16 234.38 119.69 234.21 119.69 234.21L127.86 237.44H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.68 234.21L129.22 334.47",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M127.85 237.45L137.47 334.47",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M122.92 238.08L131.47 332.17H135.05L126.03 239.06L122.92 238.08Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.25 312.68V286.47L66.75 276.34L67.09 232.43C67.09 232.43 68.75 219.83 83.18 219.83C97.61 219.83 159.05 214.79 159.05 214.79V212.81L151.96 205.66",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M159.05 214.79H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.41 351.23V346.85H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.68 236.08H89.47C89.47 236.08 79.73 236.29 80.02 242.63L80.12 244.94L83.68 324.76C83.68 324.76 84.24 331.36 90.09 332.16H129.03",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M80.13 245.87H120.71",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.68 257.41H121.89",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.19 268.81H122.99",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M81.71 280.38H124.07",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M82.21 291.71H125.2",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.71 302.97H126.28",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M83.22 314.43H127.36",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.79 325.46H128.36",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M128.66 245.53H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M129.83 257.41H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M130.96 268.81H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M132.11 280.38H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M133.23 291.71H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M134.35 302.97H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M135.49 314.43H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M136.58 325.46H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M96.88 3.66016L98.41 37.7802C98.41 37.7802 100.58 49.7601 112.32 49.7601C124.06 49.7601 174.75 49.7601 174.75 49.7601",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M44.54 170.47H17.22L14.64 172.98V188.55L17.33 191.24L35.17 191.57",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38.66 230.55L34.28 208.78C34.14 208.1 33.67 207.54 33.02 207.3L30.13 206.21C29.35 205.92 28.83 205.17 28.83 204.34C28.83 203.23 27.93 202.34 26.83 202.34H23.88C23.61 202.34 23.34 202.28 23.09 202.18L20.41 201.03C20.07 200.89 19.78 200.65 19.57 200.36L8.24001 184.54C7.86001 184.02 7.26 183.7 6.61 183.7H5.31999C2.93999 183.7 1 181.77 1 179.38V134.81C1 134.31 1.19 133.83 1.52 133.46L4.83 129.83C5.21 129.41 5.75 129.18 6.31 129.18H16.28C16.94 129.18 17.56 129.51 17.93 130.05L18.9 131.47C19.13 131.8 19.25 132.2 19.25 132.6V170.45",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.83 191.29C19.83 191.29 24.07 197.27 24.23 197.3C24.39 197.33 29.85 197.3 29.85 197.3V194.04L27.3 191.43",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M105.43 205.66L115.32 218.11",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M112.9 205.66L120.88 212.81H159.05",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M31.42 323.87C39.9583 323.87 46.88 316.949 46.88 308.41C46.88 299.872 39.9583 292.95 31.42 292.95C22.8817 292.95 15.96 299.872 15.96 308.41C15.96 316.949 22.8817 323.87 31.42 323.87Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M31.29 321.3C38.4089 321.3 44.18 315.529 44.18 308.41C44.18 301.291 38.4089 295.52 31.29 295.52C24.171 295.52 18.4 301.291 18.4 308.41C18.4 315.529 24.171 321.3 31.29 321.3Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M53.84 318.51C57.6839 318.51 60.8 315.394 60.8 311.55C60.8 307.706 57.6839 304.59 53.84 304.59C49.9961 304.59 46.88 307.706 46.88 311.55C46.88 315.394 49.9961 318.51 53.84 318.51Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M53.84 316.89C56.7892 316.89 59.18 314.499 59.18 311.55C59.18 308.601 56.7892 306.21 53.84 306.21C50.8908 306.21 48.5 308.601 48.5 311.55C48.5 314.499 50.8908 316.89 53.84 316.89Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64 183.7H14.64",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M149.45 91.15C147.8 91.15 146.45 89.8 146.45 88.15V79.47C146.45 77.82 147.8 76.47 149.45 76.47C151.1 76.47 152.45 77.82 152.45 79.47V88.15C152.45 89.8 151.1 91.15 149.45 91.15Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M70.51 91.15C68.86 91.15 67.51 89.8 67.51 88.15V79.47C67.51 77.82 68.86 76.47 70.51 76.47C72.16 76.47 73.51 77.82 73.51 79.47V88.15C73.51 89.8 72.16 91.15 70.51 91.15Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 91.15C173.1 91.15 171.75 89.8 171.75 88.15V79.47C171.75 77.82 173.1 76.47 174.75 76.47",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M15.64 402.42C15.64 402.42 15.57 427.5 21 427.5C26.42 427.5 53 427.5 53 427.5C53 427.5 58.25 425.14 58.19 409.33",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M110.38 168.38H61.26V170.47H110.38V168.38Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M110.38 168.38L122.92 174.95H113.73L110.38 170.47V168.38Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 3.06006L257.79 3.70006C257.79 3.70006 269.64 3.79006 274.32 8.17006C279 12.5501 285.64 23.8301 287.43 27.9101C289.22 32.0001 299.43 91.7401 299.43 91.7401L300.75 109.27L304.96 170.46L302.92 172.67L303.01 187.22L306.5 191.56H314.33V197.09H308.71V209.52L300.62 234.12H298.45V230.8L293.85 232.84V251.99H299.08L300.48 246.12H306.99L310.82 242.67V230.54C310.82 230.54 323.33 241.39 326.91 247.65C330.48 253.91 340.78 278.97 340.19 304.67L338.32 307.39V312.67L343.94 316.76C343.94 316.76 345.3 375.82 338.92 390.89C332.54 405.95 333.86 402.42 333.86 402.42C333.86 402.42 329.09 408.57 324.37 409.27C319.65 409.97 288.8 409.27 288.8 409.27L270.59 413.44L174.76 414.97",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M257.79 3.69995C257.79 3.69995 261.05 12.17 261.9 21.61C262.75 31.06 265.99 95.8199 265.99 95.8199",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 95.8301H279.94C279.94 95.8301 294.58 97.0201 296.96 113.53L300.79 173.06C300.79 173.06 301.23 177.63 299.34 177.63C297.46 177.63 174.74 177.63 174.74 177.63",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 98.52H278.59C278.59 98.52 292.27 99.63 294.49 115.06L298.07 170.68C298.07 170.68 298.48 174.95 296.72 174.95C294.96 174.95 174.75 174.95 174.75 174.95",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M299.34 177.64L274.83 204C274.83 204 273.39 205.5 272.66 205.66C271.93 205.82 245.15 205.66 245.15 205.66H197.53H174.74",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M190.45 212.81H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M303.77 246.13C303.77 246.13 276.88 297.45 276.71 334.47L283.05 333.07M283.05 333.07C283.05 333.07 283.52 316.79 289.14 305.24C294.76 293.69 321.18 276.64 321.18 276.64C321.18 276.64 326.99 272.62 331.78 279.32C331.78 279.32 334.8 283.13 334.84 286.98C334.88 290.83 334.84 318.26 334.84 318.26C334.84 318.26 330.88 321.96 325.14 323.75C319.4 325.54 283.05 333.07 283.05 333.07Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M338.32 312.68C338.32 312.68 338.28 320.49 335.98 323.87C333.68 327.25 329.72 331.08 321.94 333.19C314.15 335.3 282.88 341.1 282.88 341.1C282.88 341.1 274.65 343.59 273.94 347.23L276.71 334.46",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M344.05 325.78C344.05 325.78 342.83 333.06 338.32 336.89C333.81 340.72 291.94 349.66 291.94 349.66C291.94 349.66 274.51 352.6 272.92 357.32L273.94 347.23",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M318.37 364.34L304.45 365.36C304.45 365.36 300.68 366.13 299.85 369.57C299.02 373.02 297.13 384.55 297.13 384.55L308.48 383.83C308.48 383.83 313.94 383.79 316.62 379.15C319.3 374.51 320.71 366.89 320.71 366.89C320.71 366.89 321.43 364.11 318.37 364.34Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M285.68 364.33L319.13 361.02C319.13 361.02 325 360.38 324.75 365.49C324.5 370.6 319.52 381.58 319.52 381.58C319.52 381.58 316.84 386.11 311.48 387.32C306.12 388.53 284.16 389.87 284.16 389.87",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M271.64 364.33C271.64 364.33 270.17 375.39 266.53 382.09C262.89 388.79 257.91 394.41 244.96 395.11V413.86",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M244.96 395.1H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 386.38C174.75 386.38 225.52 386.47 242.07 386.38C258.62 386.29 259.41 369.02 259.41 369.02C259.41 369.02 259.82 364.64 256.54 364.68C253.26 364.72 174.75 364.68 174.75 364.68",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 342.64C174.75 342.64 251.3 342.77 261.73 342.64C272.16 342.51 276.02 337.65 276.02 337.65C276.02 337.65 270.92 351.23 266.07 351.23C261.22 351.23 174.75 351.23 174.75 351.23",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 334.08C174.75 334.08 255.46 335.2 261.11 334.08C266.76 332.96 267.68 325.78 267.68 325.78L271.64 241.87C271.64 241.87 271.94 234.04 261.64 234.21C251.34 234.38 229.81 234.21 229.81 234.21L221.64 237.44H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M229.81 234.21L220.28 334.47",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M221.64 237.45L212.03 334.47",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M226.58 238.08L218.03 332.17H214.45L223.47 239.06L226.58 238.08Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M279.24 312.68V286.47L282.74 276.34L282.4 232.43C282.4 232.43 280.74 219.83 266.31 219.83C251.88 219.83 190.44 214.79 190.44 214.79V212.81L197.53 205.66",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M190.45 214.79H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M194.09 351.23V346.85H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M229.81 236.08H260.02C260.02 236.08 269.76 236.29 269.47 242.63L269.37 244.94L265.81 324.76C265.81 324.76 265.25 331.36 259.4 332.16H220.46",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M269.37 245.87H228.79",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M268.81 257.41H227.61",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M268.31 268.81H226.51",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M267.79 280.38H225.42",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M267.29 291.71H224.3",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M266.78 302.97H223.22",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M266.27 314.43H222.14",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M265.71 325.46H221.14",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M220.84 245.53H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M219.66 257.41H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M218.53 268.81H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M217.39 280.38H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M216.26 291.71H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M215.15 302.97H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M214.01 314.43H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M212.92 325.46H174.75",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M252.62 3.66016L251.09 37.7802C251.09 37.7802 248.92 49.7601 237.18 49.7601C225.44 49.7601 174.75 49.7601 174.75 49.7601",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M304.96 170.47H332.28L334.85 172.98V188.55L332.16 191.24L314.32 191.57",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M310.83 230.55L315.21 208.78C315.35 208.1 315.82 207.54 316.47 207.3L319.36 206.21C320.14 205.92 320.66 205.17 320.66 204.34C320.66 203.23 321.56 202.34 322.66 202.34H325.61C325.88 202.34 326.15 202.28 326.4 202.18L329.08 201.03C329.42 200.89 329.71 200.65 329.92 200.36L341.25 184.54C341.63 184.02 342.23 183.7 342.88 183.7H344.17C346.55 183.7 348.49 181.77 348.49 179.38V134.81C348.49 134.31 348.3 133.83 347.97 133.46L344.66 129.83C344.28 129.41 343.74 129.18 343.18 129.18H333.21C332.55 129.18 331.93 129.51 331.56 130.05L330.59 131.47C330.36 131.8 330.24 132.2 330.24 132.6V170.45",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M329.66 191.29C329.66 191.29 325.42 197.27 325.26 197.3C325.1 197.33 319.64 197.3 319.64 197.3V194.04L322.19 191.43",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M244.07 205.66L234.17 218.11",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M236.6 205.66L228.62 212.81H190.45",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M318.08 323.87C326.618 323.87 333.54 316.949 333.54 308.41C333.54 299.872 326.618 292.95 318.08 292.95C309.542 292.95 302.62 299.872 302.62 308.41C302.62 316.949 309.542 323.87 318.08 323.87Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M318.21 321.3C325.329 321.3 331.1 315.529 331.1 308.41C331.1 301.291 325.329 295.52 318.21 295.52C311.091 295.52 305.32 301.291 305.32 308.41C305.32 315.529 311.091 321.3 318.21 321.3Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 318.51C299.504 318.51 302.62 315.394 302.62 311.55C302.62 307.706 299.504 304.59 295.66 304.59C291.816 304.59 288.7 307.706 288.7 311.55C288.7 315.394 291.816 318.51 295.66 318.51Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M295.66 316.89C298.609 316.89 301 314.499 301 311.55C301 308.601 298.609 306.21 295.66 306.21C292.711 306.21 290.32 308.601 290.32 311.55C290.32 314.499 292.711 316.89 295.66 316.89Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M341.85 183.7H334.85",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M200.05 91.15C201.7 91.15 203.05 89.8 203.05 88.15V79.47C203.05 77.82 201.7 76.47 200.05 76.47C198.4 76.47 197.05 77.82 197.05 79.47V88.15C197.05 89.8 198.4 91.15 200.05 91.15Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M278.98 91.15C280.63 91.15 281.98 89.8 281.98 88.15V79.47C281.98 77.82 280.63 76.47 278.98 76.47C277.33 76.47 275.98 77.82 275.98 79.47V88.15C275.98 89.8 277.33 91.15 278.98 91.15Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M174.75 91.15C176.4 91.15 177.75 89.8 177.75 88.15V79.47C177.75 77.82 176.4 76.47 174.75 76.47",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M333.85 402.42C333.85 402.42 333.93 427.5 328.5 427.5C323.08 427.5 296.5 427.5 296.5 427.5C296.5 427.5 291.24 425.14 291.3 409.33",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M234.55 168.38H185.43V170.47H234.55V168.38Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M234.55 168.38L247.09 174.95H237.9L234.55 170.47V168.38Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M29.85 197.3L34.29 208.78",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M35.17 197.1L40.79 209.53",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M314.32 197.1L308.71 209.53",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M319.64 197.3L315.21 208.78",
    stroke: "black",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 427.5,
    x2: 348,
    y2: 427.5,
    stroke: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M242.414 162.586C241.633 161.805 240.367 161.805 239.586 162.586L226.858 175.314C226.077 176.095 226.077 177.361 226.858 178.142C227.639 178.923 228.905 178.923 229.686 178.142L241 166.828L252.314 178.142C253.095 178.923 254.361 178.923 255.142 178.142C255.923 177.361 255.923 176.095 255.142 175.314L242.414 162.586ZM239.586 426.414C240.367 427.195 241.633 427.195 242.414 426.414L255.142 413.686C255.923 412.905 255.923 411.639 255.142 410.858C254.361 410.077 253.095 410.077 252.314 410.858L241 422.172L229.686 410.858C228.905 410.077 227.639 410.077 226.858 410.858C226.077 411.639 226.077 412.905 226.858 413.686L239.586 426.414ZM239 164L239 425L243 425L243 164L239 164Z",
    fill: "#2D9DC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstHeight);
export default __webpack_public_path__ + "static/media/instHeight.c33c00a8ada8d071939218a8157e5565.svg";
export { ForwardRef as ReactComponent };